import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import HomeStats from './HomeStats';
/**
 * Homepage brand hero: eyebrow, headline, lead, CTAs, and the live stats strip
 * (rendered by ./HomeStats).
 */
export default class HomeHero extends Component {
  view() {
    const title = app.forum.attribute('title') || 'BlueEmotion';
    const description = app.forum.attribute('description') || '';
    return m("section", {
      className: "HomeHero"
    }, m("div", {
      className: "container HomeHero-inner"
    }, m("div", {
      className: "HomeHero-eyebrow"
    }, app.translator.trans('glowingblue-demo.forum.home.hero.eyebrow')), m("h1", {
      className: "HomeHero-title"
    }, app.translator.trans('glowingblue-demo.forum.home.hero.headline', {
      title: m("span", {
        className: "HomeHero-accent"
      }, title, ".")
    })), description && m("p", {
      className: "HomeHero-lead"
    }, description), m("div", {
      className: "HomeHero-cta"
    }, m(Link, {
      href: app.route('index'),
      className: "Button Button--primary"
    }, m("i", {
      className: "fas fa-pen Button-icon"
    }), ' ', m("span", {
      className: "Button-label"
    }, app.translator.trans('glowingblue-demo.forum.home.hero.browse_discussions'))), m(Link, {
      href: app.route('tags'),
      className: "Button"
    }, m("span", {
      className: "Button-label"
    }, app.translator.trans('glowingblue-demo.forum.home.hero.browse_topics')))), m(HomeStats, {
      poll: this.attrs.poll
    }), m("span", {
      className: "HomeHero-mark",
      "aria-hidden": "true"
    })));
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/HomeHero', HomeHero);